var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DesignWorkshopComponent } from './workshop/workshop.component';
import { DesignerMainComponent } from './main.component';
var DesignerMainRoutingModule = /** @class */ (function () {
    function DesignerMainRoutingModule() {
    }
    DesignerMainRoutingModule = __decorate([
        NgModule({
            imports: [
                RouterModule.forChild([
                    {
                        path: '',
                        component: DesignerMainComponent,
                        children: [
                            { path: 'workshop', component: DesignWorkshopComponent },
                        ]
                    }
                ])
            ],
            exports: [
                RouterModule
            ]
        })
    ], DesignerMainRoutingModule);
    return DesignerMainRoutingModule;
}());
export { DesignerMainRoutingModule };
